<div>
    <div class="card card-box">
        <div class="card-header">
            <div class="display-4  card-header--title font-weight-bold">
                Greet Requests
            </div>
        </div>

        <div class="card-body">
            <tabset #tabset type="tabs" class="tabs-animated tabs-animated-shadow tabs-bordered" [justified]="true">
                <tab id="request" (selectTab)="getAgentGreetRequest()">
                    <ng-template tabHeading>
                        <span> Greet Requests</span>
                    </ng-template>
                    <div>
                        <div class=" justify-content-between px-4 py-3">
                            <div class="d-flex justify-content-between pb-3">
                                <div class="search-wrapper">
                                    <span class="icon-wrapper text-black">
                                        <fa-icon [icon]="['fas', 'search']"></fa-icon>
                                    </span>
                                    <input type="text" class="form-control form-control-sm rounded-pill"
                                        placeholder="ResID, Station, Concierge" [ngModelOptions]="{ standalone: true }"
                                        [(ngModel)]="searchText" />
                                </div>
                                <div class="card-header--actions">
                                    <div class="btn-group btn-group-sm" dropdown placement="bottom right">
                                        <button (click)="tabCardRequestClick()" tooltip="Refresh"
                                            class="btn d-32 p-0 btn-animated-icon btn-animated-icon--primary btn-neutral-primary ml-2"
                                            type="button">
                                            <span class="btn-wrapper--icon">
                                                <i class="ion-md-sync"></i>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="!agentGreetRequests">
                                No Greet Request
                            </div>
                            <div *ngIf="agentGreetRequests | tsearch: searchText; let filteredGreetRequests">
                                <div class="table-responsive table-scroll">
                                    <table class="table table-hover table-striped table-bordered text-nowrap mb-3"
                                        [mfData]="filteredGreetRequests" #mf="mfDataTable" [mfRowsOnPage]="100">
                                        <thead>
                                            <tr>
                                                <th class="bg-white text-left">
                                                    <mfDefaultSorter by="RESID">Res ID</mfDefaultSorter>
                                                </th>
                                                <th class="bg-white text-left">
                                                    <mfDefaultSorter by="LINKEDRESID">Retail Res ID</mfDefaultSorter>
                                                </th>
                                                <th class="bg-white text-left">
                                                    <mfDefaultSorter by="AIRPORTIATA">Station</mfDefaultSorter>
                                                </th>
                                                <th class="bg-white text-left">
                                                    <mfDefaultSorter by="AGENT">Concierge</mfDefaultSorter>
                                                </th>
                                                <th class="bg-white text-left">Request Date</th>
                                                <th class="bg-white text-left">Greet Start Time</th>
                                                <th class="bg-white text-center">Weekly <br />Accepted | Capacity</th>
                                                <th class="bg-white text-center">Daily <br />Accepted | Capacity</th>
                                                <th class="bg-white text-left">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let greet of mf.data let i=index;">
                                                <td class="font-weight-bold">
                                                    {{greet.RESID}}
                                                </td>
                                                <td class="font-weight-bold">
                                                    {{greet.LINKEDRESID}}
                                                </td>
                                               
                                                <td class="text-left">
                                                    {{greet.AIRPORTIATA}}
                                                </td>
                                                <td class="text-left">
                                                    {{greet.AGENT}}
                                                </td>

                                                <td class="text-left ">
                                                    <span>{{getTime(greet.DATE_TIME)}}
                                                    </span>
                                                </td>
                                                <td class="text-left ">
                                                    <span>{{getTime(greet.STARTDT)}}
                                                    </span>
                                                </td>


                                                <td class="text-left ">
                                                    <span *ngIf="greet.WEEKLY_ACCEPTED >= greet.WEEKLY_CAP"
                                                        class="badge-neutral-danger px-3 text-danger font-weight-bold">{{greet.WEEKLY_ACCEPTED}}</span>
                                                    <span *ngIf="greet.WEEKLY_ACCEPTED < greet.WEEKLY_CAP"
                                                        class="badge-neutral-success px-3  text-success font-weight-bold">{{greet.WEEKLY_ACCEPTED}}</span>
                                                    &nbsp;&nbsp;
                                                    <span
                                                        class="badge-neutral-primary px-3 text-primary font-weight-bold">{{greet.WEEKLY_CAP}}</span>
                                                </td>
                                                <td class="text-left ">
                                                    <span *ngIf="greet.DAILY_ACCEPTED >= greet.DAILY_CAP"
                                                        class="text-danger badge-neutral-danger  px-3  font-weight-bold">{{greet.DAILY_ACCEPTED}}</span>
                                                    <span *ngIf="greet.DAILY_ACCEPTED < greet.DAILY_CAP"
                                                        class="text-success  badge-neutral-success  px-3 font-weight-bold">{{greet.DAILY_ACCEPTED}}</span>
                                                    &nbsp;&nbsp;
                                                    <span
                                                        class="badge-neutral-primary  px-3 text-primary font-weight-bold ">{{greet.DAILY_CAP}}</span>
                                                </td>
                                                <td class="text-left">
                                                    <button id="completeGreetBtn" (click)="assignGreet(greet)"
                                                        class="btn btn-sm btn-neutral-success btn-square"
                                                        type="button">Approve
                                                    </button> &nbsp;&nbsp;&nbsp;
                                                    <button id="completeGreetBtn" (click)="rejectGreet(greet)"
                                                        class="btn btn-sm btn-neutral-danger btn-square"
                                                        type="button">Reject
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colspan="10">
                                                    <span class="font-weight-bold">Total Request Greets: {{
                                                        filteredGreetRequests.length
                                                        }}</span> &nbsp;&nbsp;&nbsp;
                                                    <mfBootstrapPaginator [rowsOnPageSet]="[100, 200, 300]">
                                                    </mfBootstrapPaginator>
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </tab>
                <tab id="response" (selectTab)="getAgentGreetResponse()">
                    <div (click)="tabCardResponseClick()">
                        <ng-template tabHeading>
                            <span> Greet Responses</span>
                        </ng-template>
                    </div>
                    <div>
                        <div class=" justify-content-between px-4 py-3">
                            <div class="d-flex justify-content-between pb-3">
                                <div class="search-wrapper">
                                    <span class="icon-wrapper text-black">
                                        <fa-icon [icon]="['fas', 'search']"></fa-icon>
                                    </span>
                                    <input type="text" class="form-control form-control-sm rounded-pill"
                                        placeholder="ResID, Station, Concierge" [ngModelOptions]="{ standalone: true }"
                                        [(ngModel)]="searchResponseText" />
                                </div>
                                <div class="card-header--actions">
                                    <div class="btn-group btn-group-sm" dropdown placement="bottom right">
                                        <button (click)="tabCardResponseClick()" tooltip="Refresh"
                                            class="btn d-32 p-0 btn-animated-icon btn-animated-icon--primary btn-neutral-primary ml-2"
                                            type="button">
                                            <span class="btn-wrapper--icon">
                                                <i class="ion-md-sync"></i>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="agentGreetResponse | tsearch: searchResponseText; let filteredGreetResponse">
                                <div class="table-responsive table-scroll">
                                    <table class="table table-hover table-striped table-bordered text-nowrap mb-3"
                                        [mfData]="filteredGreetResponse" #mfResponse="mfDataTable" [mfRowsOnPage]="100">
                                        <thead>
                                            <tr>
                                                <th class="bg-white text-left">
                                                    <mfDefaultSorter by="RESID">Res ID</mfDefaultSorter>
                                                </th>
                                                <th class="bg-white text-left">
                                                    <mfDefaultSorter by="LINKEDRESID">Retail Res ID</mfDefaultSorter>
                                                </th>
                                                <th class="bg-white text-left">
                                                    <mfDefaultSorter by="AIRPORTIATA">Station</mfDefaultSorter>
                                                </th>
                                                <th class="bg-white text-left">
                                                    <mfDefaultSorter by="AGENT">Concierge</mfDefaultSorter>
                                                </th>
                                                <th class="bg-white text-left">Request Date</th>
                                                <th class="bg-white text-left">Greet Start Time</th>
                                                <th class="bg-white text-left">Action By</th>
                                                <th class="bg-white text-left">Status</th>
                                                <th class="bg-white text-left">Reason</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let greetResponse of mfResponse.data let p=index;">
                                                <td class="font-weight-bold">
                                                    {{greetResponse.RESID}}
                                                </td>
                                                <td class="font-weight-bold">
                                                    {{greetResponse.LINKEDRESID}}
                                                </td>
                                                <td class="text-left">
                                                    {{greetResponse.AIRPORTIATA}}
                                                </td>
                                                <td class="text-left">
                                                    {{greetResponse.AGENT}}
                                                </td>

                                                <td class="text-left ">
                                                    <span>{{getTime(greetResponse.REQUEST_TIME)}}
                                                    </span>
                                                </td>
                                                <td class="text-left ">
                                                    <span>{{getTime(greetResponse.STARTDT)}}
                                                    </span>
                                                </td>
                                                <td class="text-left ">
                                                    <span>{{greetResponse.ADMIN}}
                                                    </span>
                                                </td>
                                                <td class="text-left">
                                                    <span *ngIf="greetResponse.STATUS == 'Approved' "
                                                        class="badge badge-success px-3">{{greetResponse.STATUS}}</span>
                                                    <span *ngIf="greetResponse.STATUS == 'Rejected' "
                                                        class="badge badge-danger px-3">{{greetResponse.STATUS}}</span>
                                                    <span *ngIf="greetResponse.STATUS == 'Failed' "
                                                        class="badge badge-danger px-3">{{greetResponse.STATUS}}</span>
                                                </td>
                                                <td class="text-left ">
                                                    <span>{{greetResponse.REASON}}
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colspan="10">
                                                    <span class="font-weight-bold">Total Response Greets: {{
                                                        filteredGreetResponse.length
                                                        }}</span> &nbsp;&nbsp;&nbsp;
                                                    <mfBootstrapPaginator [rowsOnPageSet]="[100, 200, 300]">
                                                    </mfBootstrapPaginator>
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </tab>
            </tabset>
        </div>
    </div>
</div>
<ngx-spinner [fullScreen]="false" size="medium" type="ball-spin-clockwise"></ngx-spinner>
<notifier-container></notifier-container>